import GuideReader from '../components/documentation/GuideReader';
import { userGuide } from '../content/userGuide';

export default function UserDocumentation() {
  return <GuideReader title="Guía del usuario" articles={userGuide} />;
}
